module.exports = __webpack_public_path__ + "img/thames.40cb0f91.jpg";